import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import { NAVIGATION } from '../../../config';
import { logout } from '../../../redux/actions/login';
import { getSelectedOrganization } from '../../../selectors/organizations/organizations';
import { getMemberInfo } from '../../../selectors/session/session';
import { Organization } from '../../../types/entities';
import { i18n } from '../../../utils';
import { Text } from '../../common';
import { Link } from '../../link/link';
import HeaderDropdown from '../header-dropdown/header-dropdown';
import styles from './user-profile.scss';

const MAX_HEIGHT_OF_DROPDOWN: number = 360;

interface Props {
  memberInfo: any;
  logout: any;
  selectedOrganization: Organization | undefined;
  className?: string;
}

class UserProfile extends React.PureComponent<Props, {}> {
  constructor(props) {
    super(props);

    this.state = {
      isTermsOfUseOpen: false,
      isPrivacyPolicyOpen: false,
      isSshKeysOpen: false,
    };
  }

  public onLogout() {
    this.props.logout();
  }

  public getDropdownContent() {
    const { memberInfo, selectedOrganization } = this.props;

    return (
      <div className={styles.wrapper} data-hook="user-profile-dropdown-content">
        <div className={styles.userProfile}>
          <div>
            <div className={styles.avatarBig}>
              {memberInfo.avatar && <img src={memberInfo.avatar} />}
            </div>
          </div>

          <div className={styles.info}>
            <Text weight="normal">{memberInfo.name}</Text>

            <div className={styles.email}>
              <Text size="small" secondary>
                {memberInfo.email}
              </Text>
            </div>

            <span className={styles.logout} onClick={() => this.onLogout()}>
              {i18n.t('user-profile.logout')}
            </span>
          </div>
        </div>

        {selectedOrganization &&
          this.renderOrganizationBlock(selectedOrganization)}
      </div>
    );
  }

  public render() {
    const { memberInfo, className, selectedOrganization } = this.props;

    if (!memberInfo) {
      return <div className={styles.avatarSmall} />;
    }

    return (
      <div className={className} data-hook="user-profile">
        <HeaderDropdown
          fixedHeader={this.getDropdownContent()}
          dropdownClass={styles.userProfileDropdown}
          arrowClassName={styles.arrowWhite}
          maxHeightPixels={MAX_HEIGHT_OF_DROPDOWN}
          className={styles.clickableAreaWrapper}
        >
          {this.renderClickableArea(memberInfo, selectedOrganization)}
        </HeaderDropdown>
      </div>
    );
  }

  private renderOrganizationBlock(organization: Organization) {
    return (
      <div className={styles.organization}>
        <div className={styles.selectedOrganization}>
          <Text>{organization.name}</Text>
        </div>

        <div>
          <Link path={NAVIGATION.ORGANIZATION_SELECT_STATE} theme="blue">
            {i18n.t('user-profile.change-organization')}
          </Link>
        </div>
      </div>
    );
  }

  private renderClickableArea(
    memberInfo: any,
    organization: Organization | undefined,
  ) {
    return (
      <div className={classNames(styles.clickableArea)}>
        <div className={styles.avatarSmall}>
          {memberInfo.avatar && <img src={memberInfo.avatar} />}
        </div>

        <div className={styles.clickableAreaInfo}>
          <Text size="small" ellipsis>
            {memberInfo.name || memberInfo.email}
          </Text>

          {organization && (
            <div className={classNames(styles.clickableAreaOrganizationName)}>
              {organization.name}
            </div>
          )}
        </div>

        <div className={styles.clickableAreaArrow}>
          <ChevronDown />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  memberInfo: getMemberInfo(state),
  selectedOrganization: getSelectedOrganization(state),
});

const mapDispatchToProps = {
  logout,
};

export const UserProfileContainer = connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(UserProfile);
